import { CaretDownOutlined } from "@ant-design/icons";
import { Select } from "antd";


const CustomSelect = ({ width, prefixIcon, children, ...rest }) => {
    return (
        <div className="relative custom-ant-select">
            {prefixIcon &&
                <div className="absolute top-[9px] left-2.5 flex items-center justify-center z-30">
                    <img className="w-3.5 h-3.5" src={prefixIcon} alt="sort-icon" />
                </div>}
            <Select {...rest} className={`${width && width}`} suffixIcon={<CaretDownOutlined />}>{children}</Select>
        </div>
    );
};

export default CustomSelect;